import { FC } from 'react';

import { Typography } from '@mui/material';

import { getBadgeForTicket } from 'utils/TicketBadgeUtils';

import { Notification } from 'components/NotificationCenter/Notification';

import {
  ClinicianCommentNotification,
  ClinicianNotification
} from 'components/NotificationCenter/types';
import {
  getNotificationSummary,
  getNotificationTicketClassText
} from 'components/NotificationCenter/utils';

interface Props {
  notification: ClinicianCommentNotification;
  onClick: (notification: ClinicianNotification) => void;
  onNotificationDelete: (notificationId: number) => void;
  onNotificationMarkAsRead: (notificationId: number) => void;
  onNotificationMarkAsUnread: (notificationId: number) => void;
}

export const CommentNotification: FC<Props> = ({
  notification,
  onClick,
  onNotificationDelete,
  onNotificationMarkAsUnread,
  onNotificationMarkAsRead
}) => {
  const { changeCreatedBy, patient, ticket } = notification.notificationDetails;

  const ticketOrTask = getNotificationTicketClassText(ticket);
  const title = (
    <>
      <Typography variant="body1">
        {changeCreatedBy?.firstName} {changeCreatedBy?.lastName}
      </Typography>{' '}
      commented on a {ticketOrTask} assigned to you for{' '}
      <Typography variant="body1">
        {patient?.firstName} {patient?.lastName}
      </Typography>
    </>
  );

  const summary = getNotificationSummary(ticket);
  const badge = getBadgeForTicket(ticket.ticketClass, ticket.ticketKind, ticket.urgency);

  return (
    <Notification
      notification={notification}
      onClick={onClick}
      summary={summary}
      badge={badge}
      title={title}
      removeNotification={onNotificationDelete}
      markAsReadNotification={onNotificationMarkAsRead}
      markAsUnreadNotification={onNotificationMarkAsUnread}
    />
  );
};
